import React, { useState, useEffect, useRef } from "react";
import axiosConfig from "../../Service/AxiosConfig";
import DataTable from "react-data-table-component";
import Select from "react-select";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { FaChevronDown } from "react-icons/fa";
import { HiArrowDownTray } from "react-icons/hi2";
import { FaTrashAlt } from "react-icons/fa";
import { PopupModal } from "../../PopupModal/PopupModal";
import ShowDeleteModal from "../../Modal/ShowDeleteModal";
import uploadIcon from "../../Assets/img-upload.png";
const MAX_FILE_SIZE = 5 * 1024 * 1024;
const ALLOWED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "application/pdf",
];

const QualificationRole = ({ form, setForm, fetchBooking }) => {
  const [expanded, setExpanded] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [saving, setSaving] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [newDocs, setNewDocs] = useState([]);
  const [popupType, setPopupType] = useState("");
  const [message, setMessage] = useState("");
  const fileInputRef = useRef(null);
  const [error, setError] = useState("");
  const [isDirty, setIsDirty] = useState(false);
  const [serviceItem, setServiceItem] = useState([]);
  const [education, setEducation] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const hasFocusedOnce = useRef(false);
  const serviceOptions = serviceItem.map((s) => ({
    value: s.id,
    label: s.service_name || s.name,
  }));
  const fieldsToCheck = ["services", "education_level", "documents"];
  const hasAnyData =
    !!form?.services ||
    (Array.isArray(form?.education_level) && form.education_level.length > 0) ||
    documents.length > 0;

  useEffect(() => {
    if (!form?.id) return;
    const hasData =
      (form.services && form.services !== null) ||
      (Array.isArray(form.education_level) &&
        form.education_level.length > 0) ||
      (Array.isArray(form.documents) &&
        form.documents.some((doc) => doc.document_type === "education_files"));

    setEditMode(!hasData);
  }, [form?.id]);

  useEffect(() => {
    if (!expanded) return;
    const isApiDataEmpty = fieldsToCheck.every(
      (key) => !form?.[key] || String(form[key]).trim() === "",
    );
    if (isApiDataEmpty) {
      setTimeout(() => {
        hasFocusedOnce.current = true;
      }, 0);
    }
  }, [expanded, form]);
  useEffect(() => {
    axiosConfig
      .get("/catlog/services/?is_suspended=false")
      .then((res) => setServiceItem(res?.data?.results || []));
  }, []);
  useEffect(() => {
    axiosConfig.get("/masters/education-levels/").then((res) => {
      const options = (res?.data?.results || []).map((p) => ({
        value: p.id,
        label: p.level,
      }));
      setEducation(options);
    });
  }, []);

  useEffect(() => {
    if (!form?.documents) return;

    const normalized = form.documents
      .filter((doc) => doc.document_type === "education_files")
      .map((doc) => ({
        id: doc.id,
        name: doc.document_url?.split("/").pop(),
        preview: doc.document_url,
        is_verified: doc.is_verified || false,
        isNew: false,
      }));

    setDocuments(normalized);
  }, [form?.documents]);

  const handleUpload = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = [];

    for (const file of files) {
      if (!ALLOWED_TYPES.includes(file.type)) {
        setPopupType("error");
        setError("Only JPG, PNG or PDF allowed");
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        setPopupType("error");
        setError("Max file size 5MB");
        return;
      }

      validFiles.push({
        id: Date.now() + Math.random(),
        name: file.name,
        file,
        preview: URL.createObjectURL(file),
        is_verified: false,
        isNew: true,
      });
    }

    setDocuments((prev) => [...prev, ...validFiles]);
    setNewDocs((prev) => [...prev, ...validFiles]);
  };

  const handleSave = async () => {
    setSaving(true);

    try {
      const payload = new FormData();

      if (form.services) {
        payload.append("services", form.services);
      }

      (form.education_level || []).forEach((id) => {
        payload.append("education_level", id);
      });

      newDocs.forEach((doc, i) => {
        payload.append(`documents[${i}].file`, doc.file);
        payload.append(`documents[${i}].type`, "education_files");
      });

      await axiosConfig.patch(`/provider-data/providers/${form?.id}/`, payload);
      setIsDirty(false);
      setExpanded(false);
      setEditMode(false);
      setNewDocs([]);
      setPopupType("success");
      setMessage("Role & Qualification Saved Successfully");
      fetchBooking();
    } catch (err) {
      setPopupType("error");
      setError("Save failed");
    } finally {
      setSaving(false);
    }
  };
  const confirmDelete = async () => {
    try {
      const isExistingDoc = documents.find(
        (d) => d.id === deleteId && !d.isNew,
      );
      if (isExistingDoc) {
        await axiosConfig.delete(`/provider-data/documents/${deleteId}/`);
      }
      setDocuments((prev) => prev.filter((d) => d.id !== deleteId));
      setNewDocs((prev) => prev.filter((d) => d.id !== deleteId));
      setPopupType("success");
      setMessage("Document deleted successfully");
    } catch {
      setPopupType("error");
      setError("Delete failed");
    } finally {
      setShowDeletePopup(false);
    }
  };

  const columns = [
    {
      name: "S.No",
      selector: (_, index) => index + 1,
      width: "80px",
    },
    {
      name: "File Name",
      selector: (row) => row.name,
    },
    {
      name: "Status",
      cell: (row) => (
        <p style={{ color: row.is_verified ? "green" : "red" }}>
          {row.is_verified ? "Verified" : "Not Verified"}
        </p>
      ),
    },
    {
      name: "Actions",
      width: "120px",
      cell: (row) => (
        <div style={{ display: "flex", gap: 12 }}>
          <button
            aria-label="Delete document"
            disabled={!editMode}
            onClick={() => {
              if (!editMode) return;
              setDeleteId(row?.id);
              setShowDeletePopup(true);
            }}
            style={{ background: "none", border: "none", cursor: "pointer" }}
          >
            <FaTrashAlt size={14} color={editMode ? "red" : "#ccc"} />
          </button>

          {!row.isNew && (
            <a href={row.preview} download>
              <HiArrowDownTray size={18} />
            </a>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <Accordion
        key={expanded ? "open" : "closed"}
        allowZeroExpanded
        preExpanded={expanded ? ["qualification"] : []}
        onChange={(uuids) => {
          setExpanded(uuids.includes("qualification"));
        }}
      >
        <AccordionItem uuid="qualification">
          <AccordionItemHeading>
            <AccordionItemButton className="bd-header">
              <h4 className="bd-title">Qualification & Role</h4>
              <span className="bd-add-btn">
                Add Details
                <FaChevronDown
                  style={{
                    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "0.3s",
                    marginLeft: 5,
                  }}
                />
              </span>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="bd-panel">
            <div className="bd-section-grid bd-grid-3 service-cards">
              <div className="form-group two-divide">
                <label
                  className={`form-label ${!editMode ? "view-mode-label" : ""}`}
                >
                  Applying For
                </label>
                <Select
                  name="services"
                  className={`${!editMode ? "view-mode-text" : ""}`}
                  options={serviceOptions}
                  value={
                    serviceOptions.find((opt) => opt.value === form.services) ||
                    null
                  }
                  onChange={(selected) =>
                    setForm((prev) => ({
                      ...prev,
                      services: selected ? selected.value : null,
                    }))
                  }
                  isDisabled={!editMode}
                  placeholder="Select Service"
                  isClearable
                  classNamePrefix="height-select"
                />
              </div>

              <div className="form-group two-divide">
                <label
                  className={`form-label ${!editMode ? "view-mode-label" : ""}`}
                >
                  Qualification
                </label>
                <Select
                  options={education}
                  isMulti
                  value={education.filter((opt) =>
                    (form.education_level || []).includes(opt.value),
                  )}
                  onChange={(selected) =>
                    setForm((prev) => ({
                      ...prev,
                      education_level: selected?.map((opt) => opt.value) || [],
                    }))
                  }
                  isDisabled={!editMode}
                  placeholder="Select Qualification"
                  isClearable
                  classNamePrefix="height-select"
                  className={`${!editMode ? "view-mode-text" : ""}`}
                />
              </div>
              <div className="form-group full-width">
                <div
                  className="document-upload-box"
                  onClick={() => {
                    if (!editMode) return;
                    fileInputRef.current?.click();
                  }}
                  style={{
                    cursor: editMode ? "pointer" : "not-allowed",
                  }}
                >
                  <input
                    type="file"
                    hidden
                    multiple
                    ref={fileInputRef}
                    onChange={handleUpload}
                    disabled={!editMode}
                  />
                  <img
                    src={uploadIcon}
                    alt="upload"
                    className="document-upload-icon"
                  />
                  <p>Click here to upload your education certificate</p>
                </div>
                <DataTable
                  columns={columns}
                  data={documents}
                  dense
                  highlightOnHover
                  progressPending={saving}
                  noDataComponent="No documents uploaded"
                />
              </div>

              <div className="form-group full-width">
                <div className="bd-actions">
                  {!editMode ? (
                    <button
                      className="bd-edit-btn"
                      onClick={() => {
                        setEditMode(true);
                        setIsDirty(true);
                        setExpanded(true);
                      }}
                    >
                      Edit
                    </button>
                  ) : (
                    hasAnyData &&
                    editMode && (
                      <button
                        className="bd-save-btn"
                        onClick={handleSave}
                        disabled={saving}
                      >
                        Save
                      </button>
                    )
                  )}
                </div>
              </div>
            </div>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>

      {showDeletePopup && (
        <ShowDeleteModal
          open={showDeletePopup}
          onConfirm={confirmDelete}
          onCancel={() => setShowDeletePopup(false)}
        />
      )}

      {popupType && (
        <PopupModal
          setpopupType={setPopupType}
          popupType={popupType}
          error={error}
          Message={message}
          setMessage={setMessage}
        />
      )}
    </>
  );
};

export default QualificationRole;
